import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-delivery-truck-01-grey',
  standalone: true,
  templateUrl: '../../assets/delivery-truck-01-grey.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamDeliveryTruck01GreyIcon {}
